import script from "./RelatedEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedEvents.vue?vue&type=script&setup=true&lang=js"

import "./RelatedEvents.vue?vue&type=style&index=0&id=d1fc86d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1fc86d4"]])

export default __exports__